// polyfills
import 'babel-polyfill';
import 'element-closest';
import './polyfill';

import './windowExports';

// source
import './web';
import './configureWeb';
import './configurePartialUpdate';
//import './configureTurbolinks';

// css - rozdeleno na moduly
// import '../css-scss/main.scss';



// WEBPACK FOOTER //
// ./fe/web-warehouse/src/js/index.js